const getFullName = (firstName = '', lastName = '') => {
  const trimmedFirstName = firstName.trim();
  const trimmedLastName = lastName ? lastName.trim() : '';

  return trimmedLastName ? `${trimmedFirstName} ${trimmedLastName}` : trimmedFirstName;
};

export default getFullName;
